import React, { Component, Suspense } from 'react';

// Keep navigation usable if a deferred page fails to download or render.
class PageErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (this.state.failed) {
      return <div role="alert" className="flex h-full flex-col items-center justify-center gap-3 p-6 text-center text-sm text-slate-600">
        <p>Couldn’t open this page. Reload to try again.</p>
        <button type="button" onClick={() => window.location.reload()} className="rounded-lg bg-cyan-700 px-4 py-2 font-semibold text-white">Reload page</button>
      </div>;
    }
    return this.props.children;
  }
}

export default function PageLoadBoundary({ pageKey, children }) {
  return <PageErrorBoundary key={pageKey}>
    <Suspense fallback={<div role="status" className="flex h-full items-center justify-center text-sm text-slate-500">Opening page…</div>}>
      {children}
    </Suspense>
  </PageErrorBoundary>;
}
